import { IImageVariant, EImageVariant } from 'common/types';

const HEADER_IMAGE_MINIMAL_WIDTH = 1440;
const HEADER_IMAGE_MINIMAL_HEIGHT = 300;
const HEADER_IMAGE_ASPECT_RATIO =
    HEADER_IMAGE_MINIMAL_WIDTH / HEADER_IMAGE_MINIMAL_HEIGHT;

const CARD_IMAGE_MINIMAL_WIDTH = 400;
const CARD_IMAGE_MINIMAL_HEIGHT = 220;
const CARD_IMAGE_ASPECT_RATIO =
    CARD_IMAGE_MINIMAL_WIDTH / CARD_IMAGE_MINIMAL_HEIGHT;

const USER_PROFILE_IMAGE_MINIMAL_WIDTH = 130;
const USER_PROFILE_IMAGE_MINIMAL_HEIGHT = 130;
const USER_PROFILE_IMAGE_ASPECT_RATIO =
    USER_PROFILE_IMAGE_MINIMAL_WIDTH / USER_PROFILE_IMAGE_MINIMAL_HEIGHT;

const LOGO_MINIMAL_WIDTH = 320;
const LOGO_MINIMAL_HEIGHT = 120;
const LOGO_ASPECT_RATIO = LOGO_MINIMAL_WIDTH / LOGO_MINIMAL_HEIGHT;

const FAVICON_MINIMAL_WIDTH = 256;
const FAVICON_MINIMAL_HEIGHT = 256;
const FAVICON_ASPECT_RATIO = FAVICON_MINIMAL_WIDTH / FAVICON_MINIMAL_HEIGHT;

const DRAWER_HEADER_MINIMAL_WIDTH = 768;
const DRAWER_HEADER_MINIMAL_HEIGHT = 250;
const DRAWER_HEADER_ASPECT_RATIO =
    DRAWER_HEADER_MINIMAL_WIDTH / DRAWER_HEADER_MINIMAL_HEIGHT;

export const IMAGE_VARIANTS: Record<EImageVariant, IImageVariant> = {
    [EImageVariant.Header]: {
        minWidth: HEADER_IMAGE_MINIMAL_WIDTH,
        minHeight: HEADER_IMAGE_MINIMAL_HEIGHT,
        aspectRatio: HEADER_IMAGE_ASPECT_RATIO,
    },
    [EImageVariant.Card]: {
        minWidth: CARD_IMAGE_MINIMAL_WIDTH,
        minHeight: CARD_IMAGE_MINIMAL_HEIGHT,
        aspectRatio: CARD_IMAGE_ASPECT_RATIO,
    },
    [EImageVariant.UserProfile]: {
        minWidth: USER_PROFILE_IMAGE_MINIMAL_WIDTH,
        minHeight: USER_PROFILE_IMAGE_MINIMAL_HEIGHT,
        aspectRatio: USER_PROFILE_IMAGE_ASPECT_RATIO,
    },
    [EImageVariant.Logo]: {
        minWidth: LOGO_MINIMAL_WIDTH,
        minHeight: LOGO_MINIMAL_HEIGHT,
        aspectRatio: LOGO_ASPECT_RATIO,
    },
    [EImageVariant.Favicon]: {
        minWidth: FAVICON_MINIMAL_WIDTH,
        minHeight: FAVICON_MINIMAL_HEIGHT,
        aspectRatio: FAVICON_ASPECT_RATIO,
    },
    [EImageVariant.DrawerHeader]: {
        minWidth: DRAWER_HEADER_MINIMAL_WIDTH,
        minHeight: DRAWER_HEADER_MINIMAL_HEIGHT,
        aspectRatio: DRAWER_HEADER_ASPECT_RATIO,
    },
};
